module.exports = __webpack_public_path__ + "static/media/notags.f9f21498.png";